<template>
    <div>
        <template v-if="corporate_transaction_history === true">
            <div v-show="showData">
                <div class="page-top mb-1 mb-3 clearfix">
                    <div class="page-top float-left">
                        <h1 class="m-0">Account Balance: <span class="highlight-color"> (PKR {{formatAmount(current_account_balance)}})</span> </h1>
                    </div>
                </div>
                <div class="corporate-main">
                    <div class="corporate-head pb-3 clearfix">
                        <h3 class="transaction-history-head float-left"> Transaction History </h3>
                        <div class="dt-buttons" id="buttons"> </div>
                        <div class="searching float-right">
                            <input id="custom_search" type="text" class="form-control search" autocomplete="off" />
                        </div>
                    </div>
                    <table id="dt-table" class="table" style="width:100%">
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Txt ID</th>
                                <th>Transaction Type</th>
                                <th>Description</th>
                                <th>Debit</th>
                                <th>Credit</th>
                                <th>Balance</th>
                            </tr>
                        </thead>
                        <tbody v-if="!failure">
                            <tr v-for="(transaction, index) in transactions" v-bind:value="transaction.id" v-bind:key="transaction.id">
                                <td>
                                    {{transaction.transactionDate | date_format}} <br/>
                                    {{transaction.transactionDate | time_format}}
                                </td>

                                <td>
                                    {{transaction.transactionId}}
                                </td>

                                <td v-if="transaction.useCaseData.payment_description.length > 40">
                                    {{transactionType(transaction)}}
                                </td>
                                <td v-else>
                                    {{transaction.useCaseData.payment_description}}
                                </td>

                                <td v-if="transaction.text">
                                    <span v-if="transaction.payeeDisplayName">
                                        <span v-if="('Title :'+transaction.payeeDisplayName +','+ transaction.text).length > 40">
                                            {{paymentDescription1(transaction)}} <br>
                                            {{paymentDescription2(transaction)}}
                                        </span>
                                        <span v-else>
                                            Title : {{transaction.payeeDisplayName}}, {{transaction.text}}
                                        </span>
                                    </span>
                                    <span v-else>
                                        {{transaction.text}}
                                    </span>
                                </td>
                                <td v-else>
                                    <span v-if="transaction.payeeDisplayName">
                                        {{transaction.payeeDisplayName}}
                                    </span>
                                    <span v-else>
                                        ---
                                    </span>
                                </td>

                                <td v-if="transaction.useCaseData.payment_type == 'debit'">
                                    {{formatAmount(transaction.transactionAmount)}}
                                </td>
                                <td v-else>
                                    ---
                                </td>
                                <td v-if="transaction.useCaseData.payment_type == 'credit'">
                                    {{formatAmount(transaction.transactionAmount)}}
                                </td>
                                <td v-else>
                                    ---
                                </td>
                                <td v-once>
                                    {{formatAmount(accountBalance(transaction))}}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div v-show="!showData || corporate_transaction_history == null">
                <preLoader></preLoader>
            </div>
        </template>
        <template v-else-if="corporate_transaction_history === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    var account_balance = 0;
    export default {
        data() {
            return {
                transactions : null,
                current_account_balance: null,
                customer_name: null,
                failure: true,
                showData: false,
                corporate_transaction_history: null
            };
        },
        methods: {
            getTransactionHistoryData(){
                axios.post("/api/transactionHistory")
                .then(res => {
                    if(res.status == 200){
                        if(res.data.status == 200){
                            this.transactions = res.data.transactions;
                            this.current_account_balance = res.data.balance;
                            window.account_balance = res.data.balance;
                            this.customer_name = res.data.customerName;
                            this.failure = res.data.failure;
                        }else{
                            this.showAlertBox('error','System is not responding! Please try again later.');
                        }
                    }else{
                        this.showAlertBox('error','System is not responding! Please try again later.');
                    }
                })
                .then(res => {
                    this.callDataTable();
                    this.showData = true;
                })
                .catch(err => {
                    console.log(err);
                    this.showAlertBox('error','System is not responding! Please try again later.');
                });
            },
            callDataTable(){
                var dataTable = $("#dt-table").dataTable({
                    "sDom": '<"row view-pager"<"col-sm-12 highlight-color pb-2 text-right"i">><"table-holder transaction-history mb-3"t><"col-sm-12 text-center"p">r',
                    "paging":true,
                    "pageLength":100,
                    "searching":true,
                    "order":false,
                    buttons: [],
                });
                $('#custom_search').on( 'keyup', function () {
                    dataTable.fnFilter(this.value);
                });
                var buttons = new $.fn.dataTable.Buttons(dataTable,{
                    buttons : [{
                        extend: 'excel',
                        text: '<span class="fa fa-file-excel-o"></span> Excel Export',
                        exportOptions: {
                            modifier: {
                                search: 'applied',
                                order: 'applied'
                            }
                        }
                    }]
                }).container().appendTo($('#buttons'));
            },
            accountBalance(transaction){
                var balance = window.account_balance;
                if(transaction.useCaseData.payment_type == 'debit'){
                    window.account_balance = parseInt(window.account_balance) + parseInt(transaction.transactionAmount);
                }else{
                    window.account_balance = parseInt(window.account_balance) - parseInt(transaction.transactionAmount);
                }
                return balance;
            },
            transactionType(transaction){
                if((transaction.useCaseData.payment_description).length > 40){
                    var str = transaction.useCaseData.payment_description;
                    var res1 = str.substring(0, 39);
                    return res1;
                }
            },
            paymentDescription1(transaction){
                if(('Title :'+transaction.payeeDisplayName +','+ transaction.text).length > 40){
                    var str = 'Title :'+transaction.payeeDisplayName +','+ transaction.text;
                    var res1 = str.substring(0, 39);
                    return res1;
                }
            },
            paymentDescription2(transaction){
                if(('Title :'+transaction.payeeDisplayName +','+ transaction.text).length > 40){
                    var str = 'Title :'+transaction.payeeDisplayName +','+ transaction.text;
                    var res2 = str.substring(39, str.length);
                    return res2;
                }
            }
        },
        mounted() {
			this.can('corporate_transaction_history').then(result => {
                this.corporate_transaction_history = result.corporate_transaction_history;
            }).then(result => {
                if(this.corporate_transaction_history == true){
					this.getTransactionHistoryData();
                }
            });

        },
    }
</script>
